// extracted by mini-css-extract-plugin
export var author = "style-module--author--b93c0";
export var author__description = "style-module--author__description--97d9e";
export var author__image = "style-module--author__image--6fc31";
export var author__title = "style-module--author__title--8507d";
export var author__wrapper = "style-module--author__wrapper--381aa";